import { type Theme, css } from '@emotion/react'
import { breakpoint, pxToRem, size } from '@twistopayments/design-system/styles'

export const post = (theme: Theme) => css`
  border-radius: ${theme.borderRadius.md};
  color: ${theme.palette.text.title};
  cursor: pointer;
`

export const listItemPost = (theme: Theme) => css`
  position: relative;
  color: ${theme.palette.background.main};
  border-radius: ${theme.borderRadius.lg};
  cursor: pointer;

  flex-basis: 90%;
  flex-shrink: 0;

  &::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0.265541) 18.12%,
      rgba(0, 0, 0, 0.6) 88.23%
    );
    top: 0;
    left: 0;
    border-radius: ${theme.borderRadius.lg};
  }

  img {
    min-height: 425px;
  }

  ${breakpoint.up('smMd')} {
    position: relative;
    color: ${theme.palette.background.main};
    border-radius: ${theme.borderRadius.lg};

    flex-basis: 31%;
    flex-shrink: 0;

    img {
      width: 100%;
      height: 100%;
      min-height: 525px;
      object-fit: cover;
      border-radius: ${theme.borderRadius.lg};
    }
  }
`

export const image = (theme: Theme) => css`
  width: 100%;
  height: 100%;
  max-height: 220px;
  object-fit: cover;
  border-radius: ${theme.borderRadius.lg};

  ${breakpoint.up('smMd')} {
    min-height: 0;
    max-height: 240px;
    border-radius: ${theme.borderRadius.md};
  }
`

export const listContent = (theme: Theme) => css`
  position: absolute;
  bottom: 0;
  z-index: 1;
  padding: ${size[24]};
  display: flex;
  flex-direction: column;
  gap: ${size[24]};
  border-radius: ${theme.borderRadius.lg};
`

export const content = css`
  position: static;
  padding: 0;
  gap: ${size[20]};
  margin-top: ${size[12]};
`

export const postName = css`
  margin: 0;
  font-size: ${pxToRem(18)};
  font-weight: 500;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;

  ${breakpoint.up('smMd')} {
    -webkit-line-clamp: 2;
    line-clamp: 2;
    font-weight: 700;
  }
`

export const postLink = (theme: Theme) => css`
  display: flex;
  align-items: center;
  gap: ${size[8]};
  color: ${theme.palette.background.main};
  font-size: ${pxToRem(16)};
  text-decoration: none;

  svg {
    width: ${size[20]};
    height: ${size[20]};
    transform: rotateY(180deg);
  }
`

export const details = css`
  display: flex;
  align-items: center;
  gap: ${size[16]};
`

export const badge = (theme: Theme) => css`
  padding: ${size[8]};
  background-color: ${theme.palette.secondary.mainContrast};
  border-radius: ${theme.borderRadius.lg};
  color: ${theme.palette.background.main};
  font-size: ${pxToRem(12)};
  font-weight: 500;
`

export const date = css`
  display: flex;
  align-items: center;
  gap: ${size[12]};
  font-size: ${pxToRem(16)};
`
